import { render, staticRenderFns } from "./LoaderBootstrapCustomBS46.vue?vue&type=template&id=77e18043"
import script from "./LoaderBootstrapCustomBS46.vue?vue&type=script&lang=js"
export * from "./LoaderBootstrapCustomBS46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports